import React from 'react';
import { getProductsItems } from '../../Organisms/RecentOrdersList/RecentOrderUtils';
import { REMOVE_FROM_CART } from '../../../constants/AnalyticsConstants';
import { startNewOrder } from '../../../Utils/componentUtils';
import _isEmpty from 'lodash/isEmpty';
import { ternaryCheck } from '../../../Utils/WindowUtils';
export const getContinueButtonText = (favDictonary: any, isRecentOrderPage: any) => {
    return favDictonary.continue && !isRecentOrderPage
        ? favDictonary.continue ?? favDictonary.checkoutButton
        : favDictonary.removeAndContinue
}

export const analyticsLocatorPageCondition = (removedProductData: any, isLocatorPage: any) => {
    if (isLocatorPage) {
        if (removedProductData.length > 0) {
            return true;
        } else {
            return false;
        }
    }
    return false;
};
export const onClickStartOrder = (removedProductData: any, isLocatorPage: any, virtualName: any, setAnalyticsProducts: any, setAttemptTracker: any, orderViewModel: any) => {

    removedProductData?.map((listProduct: any) => {
        if (listProduct.allOptionsList && listProduct.allOptionsList.length > 0) {
            listProduct.options = listProduct.allOptionsList
        }
    })
    const productStringData = isLocatorPage ? getProductsItems(removedProductData, isLocatorPage) : [];
    setAnalyticsProducts({
        clickActionName: 'start new order',
        componentTitle: virtualName,
        virtualName: virtualName,
        startonlineorder: 1,
        itemRemoved: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        productPriceRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        productQuantityRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        ExtrasPriceRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        ComboPriceRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        MIAMPriceRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        products: productStringData,
    });
    if (isLocatorPage) {
        setAttemptTracker([{ name: REMOVE_FROM_CART }]);
    } else {
        setAttemptTracker([{ name: 'recent_order', isClickable: true }]);
    }
    orderViewModel.flushCart()
    setTimeout(() => {
        startNewOrder();
    }, 1000);
};

interface OnClickContinueAnalyticsDataProps {
    orderViewModel: any,
    toastedEvent: any,
    upsellProductEvent: any,
    productStringData: any,
    mergeCart: boolean,
    orderTypeValue: string,
    actionName: string,
    titleComp: string,
    nameVirtual: string,
    removedProductData: any,
    isLocatorPage: any,
    cartItemId: string | undefined,
    setAnalyticsProducts: any,
}
export const onClickContinueAnalytics = (onClickContinueAnalyticsData: OnClickContinueAnalyticsDataProps) => {
    const {
        orderViewModel,
        toastedEvent,
        upsellProductEvent,
        productStringData,
        mergeCart,
        orderTypeValue,
        actionName,
        titleComp,
        nameVirtual,
        removedProductData,
        isLocatorPage,
        cartItemId,
        setAnalyticsProducts
    } = onClickContinueAnalyticsData;
    setAnalyticsProducts({
        toastedEvent: ternaryCheck(toastedEvent.length > 0,  1 , 0),
        upsellProductAddedEvent: ternaryCheck(!_isEmpty(upsellProductEvent) , 1 , 0),
        cartOpen: orderViewModel.cartOpen || !orderViewModel.currentOrder.cartId ? 1 : 0,
        products: productStringData,
        itemRemoved: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        productPriceRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        productQuantityRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        ExtrasPriceRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        ComboPriceRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        MIAMPriceRemove: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 1 : 0,
        itemAddedtoBag: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 0 : 1,
        productPriceAdded: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 0 : 1,
        productQuantityAdded: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 0 : 1,
        MIAMPriceAdded: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 0 : 1,
        ExtrasPriceAdded: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 0 : 1,
        ComboPriceAdded: analyticsLocatorPageCondition(removedProductData, isLocatorPage) ? 0 : 1,
        CYO: 0,
        cartID: mergeCart ? orderViewModel.currentOrder.cartId : cartItemId,
        orderSourceType: orderTypeValue,
        clickActionName: actionName,
        componentTitle: titleComp,
        virtualName: nameVirtual,
    });
};